import React from "react";
import Navbar from "../hero/Navbar";
import Footer from "../Footer/Footer";
import { useLocation, useNavigate } from "react-router-dom";
import { FaMapMarkerAlt, FaBed } from "react-icons/fa";
import './HotelList.css'
import hotelplace from '../../assets/hotelplace.webp';
import { getHotelImage } from '../../assets/hotelImages';
import resLogo from '../../assets/reslogo.png';

const HotelsList = () => {
  const history = useLocation();
  const navigation = useNavigate();

  const generateRandomCode = (length) => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let code = '';
    const charactersLength = characters.length;

    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * charactersLength);
      code += characters.charAt(randomIndex);
    }

    return code;
  };

  const { availableHotel, dates } = history.state;

  const passDetails = (hotel) => {
    const randomCode = generateRandomCode(20);
    const hotelId = hotel.hotelId
    const hotelName = hotel.hotelName
    navigation(`/hotel-rooms/${hotelId}/${randomCode}`, { state: { hotel, dates } });
  };

  return (
    <div>
      <Navbar />

      <section className='hl-hero'>
        <div className='hl-hero__overlay' />
        <div className='container'>
          <div className='hl-hero__inner'>
            <div className='hl-hero__content'>
              <div className='hl-hero__eyebrow'>Residency Hotels Limited</div>
              <h1 className='hl-hero__title'>Our Hotels</h1>
              <p className='hl-hero__desc'>
                {availableHotel ? availableHotel.length : 0} hotels across
                Nigeria — pick one to view rooms and rates.
              </p>
            </div>
            <div className='hl-hero__brand'>
              <img src={resLogo} alt='Residency Hotels' />
            </div>
          </div>
        </div>
      </section>

      <div className='container hl-main'>
        {history.state && history.state.dates && (
          <div className='hl-stay'>
            <FaBed />
            <span>
              Stay selected: {new Date(dates[0]).toLocaleDateString()} –{" "}
              {new Date(dates[1]).toLocaleDateString()}
            </span>
          </div>
        )}

        <div className='hl-list'>
          {availableHotel &&
            availableHotel.map((hotel) => (
              <div className='hl-card' key={hotel.hotelId}>
                <div className='hl-card__media'>
                  <img
                    src={hotel.picture}
                    onError={(e) => {
                      const match = getHotelImage(hotel.hotelName);
                      if (match && e.target.src !== match) {
                        e.target.src = match;
                      } else {
                        e.target.src = hotelplace;
                      }
                    }}
                    alt={hotel.hotelName}
                  />
                </div>
                <div className='hl-card__body'>
                  <div className='hl-card__head'>
                    <h3 className='hl-card__name'>{hotel.hotelName}</h3>
                    <div className='hl-card__price'>
                      <span className='hl-card__amount'>
                        &#8358; {hotel.hotelMinimumPrice.toLocaleString()}
                      </span>
                      <span className='hl-card__per'> / night</span>
                    </div>
                  </div>
                  <p className='hl-card__addr'>
                    <FaMapMarkerAlt /> {hotel.address}
                  </p>
                  <p className='hl-card__desc'>{hotel.shortHotelDescription}</p>
                  <div className='hl-card__chips'>
                    {hotel.amenities &&
                      hotel.amenities
                        .slice(0, 4)
                        .map((amenity, i) => (
                          <span className='hl-chip' key={i}>
                            {amenity.amenity}
                          </span>
                        ))}
                  </div>
                  <button
                    type='button'
                    className='hl-btn'
                    onClick={() => passDetails(hotel)}
                  >
                    Select Hotel
                  </button>
                </div>
              </div>
            ))}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default HotelsList;